import { CustomerAddressModel } from "../models";
import Select from "react-select";

type Props = {
  addresses: CustomerAddressModel[],
  handleChange: (option: CustomerAddressModel) => void
}

const SavedAddressOptions: React.FC<Props> = ({addresses, handleChange}) => {

  const options = addresses.map((item) => ({
    value: item.id, 
    label: `${item.address_street}, ${item.city_name}, ${item.state_code}, ${item.zip_code}`
  }));

  const handleSelection = (option: any) => {
    const selectedAddress = addresses.find(item => item.id == option.value)
    if(selectedAddress) handleChange(selectedAddress)
  }

  return (
    <>
      <Select 
        className="mb-5" 
        placeholder="Please select an address to continue"
        options={options}
        onChange={handleSelection}
        menuShouldScrollIntoView={false} />
    </>
  )
}

export default SavedAddressOptions;